import { Component } from '@angular/core';
import { NavController, NavParams ,ModalController} from 'ionic-angular';

import { RevisePage } from './revise';
import { ReviseMoneyPage } from './reviseMoney';

import { PasswordService } from './../../services/password.service';
import { LoaddingService } from '../../providers/loadding.service';
import { UserVarifyService } from '../../services/userVarify.service';
import { AlertService } from './../../providers/alert.service';


@Component({
  selector: 'page-password',
  templateUrl: 'password.html',  
  providers: [
    PasswordService,
    AlertService,
    UserVarifyService
  ]
})
export class PasswordPage {
  openWay:string;
  buttonName:string;
  way:boolean=true;
  hasMoney:boolean=false;
  wayId:number=0;
  
  segments=[
    {value:'login',name:'登录密码'},
    {value:'money',name:'资金密码'}
    ];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadding: LoaddingService,
    public modalCtrl: ModalController,
    private userService: UserVarifyService,
    private alert: AlertService,
    private reviseService: PasswordService
) {}

  ionViewDidLoad() {
    this.openWay="login";
    this.getCheckMoney();
  }

  //是否有资金密码
  //chen 2017-06-06
  getCheckMoney(){
     this.reviseService.getCheckCreateMoney().then(s=>{  
          this.hasMoney=s.Result;    
    });
  }


  //登录或资金内容
  //chen 2017-03-13
  open(){
    this.way=!this.way;
    if(this.way){
      this.openWay='login';
    }else{
      this.openWay=="money";
    }
  }

  //修改
  //chen 2017-03-13
  revise(){
    let load = this.loadding.showLoding();
    if(this.way){
      this.wayId=0;
      let modal = this.modalCtrl.create(RevisePage, {
        information: this.wayId
      });
      modal.present();
    }else{
      if(this.hasMoney){
        this.wayId=2
        this.userService.ckkUserSecurityQuestion().then(s=>{
          if(!s.Result){
            this.alert.showAlert("请前往绑定密保问题，密保问题回答正确，即可修改资金密码");
            return;
          }else{
            let modal = this.modalCtrl.create(RevisePage, {
              information: this.wayId
            });
            modal.present();            
          }
        })

      }else{
        this.wayId=1;
        let modal = this.modalCtrl.create(RevisePage, {
          information: this.wayId
        });
        modal.present();
        modal.onWillDismiss((flag:boolean) => {
              if(!this.hasMoney){
                this.hasMoney= flag;        
              }
            });
      }
    }
    this.loadding.closeLoading(load);
  }


}



// WEBPACK FOOTER //
// ./src/pages/password/password.ts